import { ArrowLeftIcon as PhosphorArrowLeftIcon } from "@phosphor-icons/react/dist/ssr/ArrowLeft";

import { createAppIcon } from "@/components/createAppIcon";

export const ArrowBackIcon = /* @__PURE__ */ createAppIcon(PhosphorArrowLeftIcon);
